import * as React from 'react';
import {LessonBuilderState} from '.';

export interface LessonBuilderContextValue {
  lesson: LessonBuilderState['lesson'];
  setLesson(course: LessonBuilderState['lesson']): void;
}

export const LessonBuilderContext
  = React.createContext<Partial<LessonBuilderContextValue>>({});

export default LessonBuilderContext;
